export default "__VITE_ASSET__CpROpZQi__"